import { render, staticRenderFns } from "./SendReport.vue?vue&type=template&id=2d4800c0&scoped=true&"
import script from "./SendReport.vue?vue&type=script&lang=ts&"
export * from "./SendReport.vue?vue&type=script&lang=ts&"
import style0 from "./SendReport.vue?vue&type=style&index=0&id=2d4800c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4800c0",
  null
  
)

export default component.exports